import api from './api'
import Cookies from "js-cookie";


export async function getOrders() {
    const res = await api.get('/api/orders', {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
    return res.data
}

export async function createOrder(order) {
    await api.post('/api/orders', order, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
}

export async function updateOrder(id, order) {
    await api.put('/api/orders/' + id, order, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
}

export async function serveItem(orderId, itemId) {
    const url = '/api/orders/' + orderId + '/items/' + itemId + '/serve';
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

export async function paymentOrder(id, action, paymentMethod) {
    // Nếu action = 1: Thanh toán (gọi /serve endpoint)
    // Nếu action là object payload: Update items trước, sau đó thanh toán
    if (typeof action === 'object' && action !== null) {
        // Update items
        await api.put('/api/orders/' + id, action, {
            headers: {
                'Authorization': `Bearer ${Cookies.get('token')}`
            }
        });
        // Sau đó gọi endpoint serve
        const serveUrl = '/api/orders/' + id + '/serve?payment=' + (paymentMethod === 'transfer');
        await api.get(serveUrl, {
            headers: {
                'Authorization': `Bearer ${Cookies.get('token')}`
            }
        });
    } else if (action === 1) {
        // Chỉ thanh toán (serve) mà không update
        const url = '/api/orders/' + id + '/serve?payment=' + (paymentMethod === 'transfer');
        await api.get(url, {
            headers: {
                'Authorization': `Bearer ${Cookies.get('token')}`
            }
        });
    }
}

export async function lenMon(id) {
    const url = '/api/orders/' + id + '/len-mon';
    await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
}

export async function serveOrderItems(orderID, itemsID) {
    const url = '/api/orders/' + orderID + '/items/' + itemsID + '/serve';
    await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
}

export async function getOrdersByTable(tableId) {
    const url = '/api/orders/get-by-table/' + tableId;
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

export async function getOrderByTable() {
    const url = '/api/orders/get-by-table';
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

export async function updateOrderItems(orderId, items) {
    const url = '/api/orders/' + orderId + '/items';

    const res = await api.get(url, {items}, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

// New: fetch all paid orders for today
export async function getOrdersToday() {
    const url = '/api/orders/paid-today';
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

export async function getOrderByMonth(month, year) {
    const url = '/api/orders/orders-by-month';
    const res = await api.get(url, {
                params: {
                    month: Number(month),
                    year: Number(year)
                },
                headers: {
                    'Authorization':
                        `Bearer ${Cookies.get('token')}`
                }
            }
        )
    ;
    return res.data;
}

export async function deleteOrderItem(itemId) {
    const url = `/api/orders/delete/items/${itemId}`
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

// Transfer order to a different table
export async function transferTable(orderId, newTableId) {
    const url = `/api/orders/${orderId}/transfer-table?newTableId=${newTableId}`;
    const res = await api.post(url, {}, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

